/**
 * Configura o axios para enviar o token JWT e trata 401 (sessão expirada).
 * Após login, chame setupAuth(token). No logout, chame setupAuth(null).
 * O App deve escutar o evento 'auth:unauthorized' para redirecionar ao login.
 */

import axios from 'axios';

const AUTH_HEADER = 'Authorization';

export function setupAuth(token) {
  if (token) {
    axios.defaults.headers.common[AUTH_HEADER] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common[AUTH_HEADER];
  }
}

// Interceptor: em 401 dispara evento para o App fazer logout
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    return Promise.reject(err);
  }
);

export const AUTH_STORAGE_KEY = 'tilti_auth';

export function getStoredAuth() {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data && data.token) return data;
  } catch (_) {}
  return null;
}

export function setStoredAuth(data) {
  if (data) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(data));
    setupAuth(data.token);
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    setupAuth(null);
  }
}
